var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"go-to-top",staticStyle:{"cursor":"pointer"},on:{"click":_vm.goToTop}},[_vm._m(0),_c('div',{staticClass:"pb-navigation colour-primary-02"},[_vm._v("Go to Top")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("@/assets/icons/arrow-up.svg")}})])
}]

export { render, staticRenderFns }